import axios from "axios";
import { API_URL } from "../variables/constants";

export const LOGOUT_REASONS = {
  VOLONTAIRE: "VOLONTAIRE",
  INACTIVITE: "INACTIVITE",
};

const getCurrentToken = () => {
  const parts = ["n", "t", "k"].map((key) => sessionStorage.getItem(key));
  if (parts.some((part) => !part || part === "null")) {
    return null;
  }
  return parts.join(".");
};

export const auditLogout = async (reason = LOGOUT_REASONS.VOLONTAIRE) => {
  const token = getCurrentToken();
  if (!token) {
    return;
  }

  try {
    await axios.post(
      `${API_URL || ""}/api/logout`,
      { reason },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 3000,
      }
    );
  } catch (error) {
    // La déconnexion locale doit rester possible même si l'audit réseau échoue.
  }
};
